import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./appSlice";
import movieReducer from "./movieSlice";
import searchReducer from "./searchResSlice";

const appStore = configureStore({
  reducer: {
    app: appReducer,
    movies: movieReducer,
    searchResults: searchReducer,
  },
});

export default appStore;
